import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const TermsConditionsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms & Conditions</h1>
          <p className="text-gray-600 mb-6">Effective Date: 2025-12-07</p>
          
          <div className="prose max-w-none">
            <p className="mb-4">
              These Terms and Conditions apply to the service provided by the Service Provider through the official website and WhatsApp-based AI Customer Service (hereinafter referred to as the "Service").
            </p>
            
            <p className="mb-4">
              By accessing the website, contacting the AI Customer Service via WhatsApp, or using any services provided by the Service Provider, you automatically agree to be bound by these Terms and Conditions. It is strongly recommended that you read and understand these terms before using the Service.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Service Scope</h2>
            <p className="mb-4">
              The Service is delivered through:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li className="mb-2">Official Website</li>
              <li className="mb-2">AI-powered Customer Service via WhatsApp</li>
            </ul>
            <p className="mb-4">
              No mobile application is provided or operated under this Service. Any reference to an "Application" does not apply to this service.
            </p>
            <p className="mb-4">
              All service details, features, pricing, and updates are accessible exclusively via the official website.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Intellectual Property</h2>
            <p className="mb-4">
              All content, branding, trademarks, logos, software, and intellectual property displayed on the website or through the WhatsApp service remain the exclusive property of the Service Provider.
            </p>
            <p className="mb-4">
              You may not copy, modify, distribute, reverse engineer, or exploit any portion of the Service without written permission from the Service Provider.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. AI Usage</h2>
            <p className="mb-4">
              The Service incorporates Artificial Intelligence (AI) technologies to provide automated responses and service assistance via WhatsApp.
            </p>
            <p className="mb-4">
              By using the Service, you acknowledge and agree that:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li className="mb-2">AI systems may process user input data.</li>
              <li className="mb-2">AI-generated responses may not always be perfect or free from error.</li>
              <li className="mb-2">The Service Provider is not responsible for decisions made based solely on AI responses.</li>
              <li className="mb-2">All AI processing is conducted in accordance with applicable laws and data protection regulations.</li>
            </ul>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. User Responsibility</h2>
            <p className="mb-4">
              You are responsible for:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li className="mb-2">Maintaining the confidentiality of any communication.</li>
              <li className="mb-2">Ensuring that the information you provide is accurate.</li>
              <li className="mb-2">Not using the Service for illegal, abusive, or harmful activities.</li>
            </ul>
            <p className="mb-4">
              The Service Provider reserves the right to restrict or terminate service access if there is misuse.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Internet and Data Usage</h2>
            <p className="mb-4">
              The Service requires an active internet connection to access the website and communicate via WhatsApp.
            </p>
            <p className="mb-4">
              Any charges related to internet usage, messaging fees, or roaming costs are the sole responsibility of the user.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="mb-4">
              The Service Provider is not liable for:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li className="mb-2">Any loss due to reliance on AI-generated information.</li>
              <li className="mb-2">Disruption caused by network issues.</li>
              <li className="mb-2">Temporary service downtime.</li>
              <li className="mb-2">Third-party service failures (including WhatsApp).</li>
            </ul>
            <p className="mb-4">
              The Service is provided on an "as-is" basis without warranty of fitness for a specific purpose.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Service Modification or Termination</h2>
            <p className="mb-4">
              The Service Provider reserves the right to:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li className="mb-2">Modify or discontinue any part of the Service at any time.</li>
              <li className="mb-2">Update pricing, features, or policies without prior notice.</li>
            </ul>
            <p className="mb-4">
              Continued use of the Service constitutes acceptance of such changes.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Changes to These Terms and Conditions</h2>
            <p className="mb-4">
              These Terms & Conditions may be updated periodically.
            </p>
            <p className="mb-4">
              Any changes will be published on the official website. Users are encouraged to review this page regularly.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Contact Us</h2>
            <p className="mb-4">
              If you have any questions regarding these Terms and Conditions, please contact:
            </p>
            <div className="bg-gray-100 p-4 rounded-md mb-6">
              <p>📧 hello@sabisolution.com</p>
            </div>
          </div>
          
          <div className="mt-8">
            <Link to="/" className="text-primary-600 hover:text-primary-800">
              &larr; Back to Home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default TermsConditionsPage;